import {
    GET_ORTHODONTIC_EXAM_BY_CUSTOMER,
    UPDATE_SPECIFIC_ORTHODONTIC_EXAM,
    REMOVE_ORTHODONTIC_EXAM,
    GET_SPECIFIC_ORTHODONTIC_EXAM
} from '@/redux/actions/types';

/**
 * initial state cho module
 */
const INIT_STATE = {
    orthodonticExamList: [],      // danh sách phiếu khám
    currentOrthodonticExam: null, // record chi tiết (edit)
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 50
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        // Lấy danh sách phiếu khám theo customer
        case GET_ORTHODONTIC_EXAM_BY_CUSTOMER: {
            return {
                ...state,
                orthodonticExamList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page || 1),
                    total: parseInt(action.payload.total || 0),
                    perPage: parseInt(action.payload.per_page || 50),
                }
            };
        }

        // Lấy 1 phiếu khám (dùng khi update)
        case GET_SPECIFIC_ORTHODONTIC_EXAM: {
            return {
                ...state,
                currentOrthodonticExam: action.payload
            };
        }


        // Cập nhật 1 phiếu khám
        case UPDATE_SPECIFIC_ORTHODONTIC_EXAM: {
            const updatedList = state.orthodonticExamList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            return {
                ...state,
                orthodonticExamList: updatedList,
                currentOrthodonticExam: action.payload
            };
        }

        // Xóa một hoặc nhiều phiếu khám
        case REMOVE_ORTHODONTIC_EXAM: {
            const filteredList = state.orthodonticExamList.filter(
                item => !action.payload.includes(item.id)
            );

            return {
                ...state,
                orthodonticExamList: filteredList,
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total - action.payload.length
                }
            };
        }

        default:
            return { ...state };
    }
};
